import { TableCell, TableHead, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const HrInternalHoursTableHead = (): JSX.Element => {
  const { t } = useTranslation('hrInternalHours')

  return (
    <TableHead>
      <TableRow>
        <TableCell>{t('table.columns.employee')}</TableCell>
        <TableCell>{t('table.columns.email')}</TableCell>
        <TableCell>{t('table.columns.year')}</TableCell>
        <TableCell>{t('table.columns.contractHours')}</TableCell>
        <TableCell>{t('table.columns.workPercentage')}</TableCell>
        <TableCell>{t('table.columns.totalHoliday')}</TableCell>
        <TableCell>{t('table.columns.usedHoliday')}</TableCell>
        <TableCell>{t('table.columns.normalHoliday')}</TableCell>
        <TableCell>{t('table.columns.nationalHoliday')}</TableCell>
        <TableCell>{t('table.columns.overtimeAdjustment')}</TableCell>
        <TableCell>{t('table.columns.crossYearsSaldo')}</TableCell>
        <TableCell>{t('table.columns.balance')}</TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
